import React from 'react'
import './tag-title.scss';

export interface IProps{
    title: string
}

const TagTitle = ({title}: IProps) => {
    return (
        <div className="wrapper-tag-title">                      
            <div className="block-tag-title">{title}</div>
        </div>
    );
}

export default TagTitle;
